export default __webpack_public_path__ + "static/Крысиные бега_12-3460348ed410f9d519d78f568524bca6.jpg";